import { call, put, takeEvery} from "redux-saga/effects";
import {
  GET_COUNTRY_STATE_DEFINITIONS,
  ADD_COUNTRY_STATE_DEFINITION,
  UPDATE_COUNTRY_STATE_DEFINITION,
  DELETE_COUNTRY_STATE_DEFINITION
  
} from "./actionTypes"

import {

  getCountryStateDefinitionSuccess,
  addCountryStateDefinitionSuccess,
  updateCountryStateDefinitionSuccess,
  deleteCountryStateDefinitionSuccess,
  countryStateError
  
} from "./actions"

//Include Both Helper File with needed methods
import {

addCountryStateDefinition,
updateCountryStateDefinition,
deleteCountryStateDefinition,
getCountryStateDefinition


} from "../../helpers/backend_helper/backend_helper"

import { toast,Zoom } from "react-toastify";
import i18n from 'i18n';

function* fetchCountryStateDefinition() {
  try {
    const response = yield call(getCountryStateDefinition)
    yield put(getCountryStateDefinitionSuccess(response))
  } catch (error) {
    yield put(countryStateError(error))
  }
}

function* onAddCountryStateDefinition({ payload: record }) {
  try {
    const response = yield call(addCountryStateDefinition, record)
    yield put(addCountryStateDefinitionSuccess(response))
  } catch (error) {
    yield put(countryStateError(error))
  }
}

function* onUpdateCountryStateDefinition({ payload: record }) {
  try {
    const response = yield call(updateCountryStateDefinition, record)
    yield put(updateCountryStateDefinitionSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(countryStateError(error))
  }
}

function* onDeleteCountryStateDefinition({ payload: guid }) {
  try {
    const response = yield call(deleteCountryStateDefinition, guid)
    yield put(deleteCountryStateDefinitionSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(countryStateError(error))
  }
}


function* countryStateDefManagementSaga() {

    yield takeEvery(GET_COUNTRY_STATE_DEFINITIONS,fetchCountryStateDefinition)
    yield takeEvery(ADD_COUNTRY_STATE_DEFINITION,onAddCountryStateDefinition)
    yield takeEvery(UPDATE_COUNTRY_STATE_DEFINITION,onUpdateCountryStateDefinition)
    yield takeEvery(DELETE_COUNTRY_STATE_DEFINITION,onDeleteCountryStateDefinition)
}

export default countryStateDefManagementSaga
